import bowser from 'yola-bowser';

const injectIOSMarker = (liveDOM) => {
  if (!bowser.ios) return;

  liveDOM.documentElement.setAttribute('data-ws-ios', true);
};

export default injectIOSMarker;
